import React from 'react'
import { connect } from 'react-redux'
import { localizedTranslate } from 'assets/localization'
import 'less/interviews/no-interviews.less'

const NoProjects = (props) => {

  return (
    <div className="no-interviews-container">
      <div className="no-interviews-oval">
        <i className="im-ss-inboxes"></i>
      </div>
      <p className="there-are-currently">
        There are currently no projects to show
      </p>
      <hr></hr>
      <p className="description">
        <div className='description' dangerouslySetInnerHTML={{
                __html: props.t('no.projects.list', {
                  markup: { tagStart: `<a href='${window.location.origin}/projects/creation'/>` }
                })
              }} />
      </p>
    </div>
  )
}

function mapStateToProps(state) {
  return {
    t: localizedTranslate('en', state.translations.en_us),
  }
}
export default connect(mapStateToProps, null)(NoProjects)